<template>
  <div>
      <IQOSTable
        :cols="[{
            title: $t('worker_tips_history.col_date'),
            key: 'created_at',
            date: true
        },
        {
            title: $t('worker_tips_history.col_time'),
            key: 'created_at',
            time: true
        },
        {
            title: $t('worker_tips_history.col_check'),
            key: 'local_id',
        },
        {
            title: $t('worker_tips_history.col_total'),
            key: 'total',
            currency: 'code'
        },
        {
            title: $t('worker_tips_history.col_pay'),
            key: 'pay_method',
        },
        {
            title: $t('worker_tips_history.col_tip'),
            key: 'tip',
            currency: 'code'
        },
        {
            title: $t('worker_tips_history.col_balance'),
            key: 'balance',
            currency: 'code'
        }]"
        :rows="history"
        >
            <template #col-pay_method="slotProps">
                {{ slotProps.rowItem.pay_method ? $t(`pay_methods.${slotProps.rowItem.pay_method}`) : '' }}
            </template>
      </IQOSTable>
  </div>
</template>

<script>
import moment from 'moment'

import WaitersAPI from '@/api/waiters'

export default {
    props: {
        waiter: Object
    },
    data() {
        return {
            fake: [{created_at:'2020-10-27', local_id: "D1CK", pay_method: "cash", total: 150, tip: 10, balance: 100},{created_at:'2020-10-27', local_id: "D1CK",pay_method: "cash", total: 150, tip: 10, balance: 100}],
            orders: [],
            history: [],

            range: {
                start: moment().startOf('month').toDate(),
                end: moment().endOf('month').toDate(),
            }
        }
    },
    methods: {
        fetchTips() {
            WaitersAPI.getTipsHistory(this.waiter._id).then(data => {
                this.history = data.history;
            });
        }
    },
    computed: {
        currency() {
            return this.$store.state.currency;
        }
    },
    mounted() {
        this.fetchTips();
    }
}
</script>

<style scoped>
.waiter-tips-table tbody {
    display: inline-table;
}

.qrw-simple-table thead th:first-child {
    width: 15vh !important;
}

.w-10 {
    width: 10%;
}

.waiter-tips-table th, .waiter-tips-table td {
    width: 15vh;
    text-align: center;
}
</style>